import { render, staticRenderFns } from "./OsmResult.vue?vue&type=template&id=04d22396&scoped=true&"
import script from "./OsmResult.vue?vue&type=script&lang=js&"
export * from "./OsmResult.vue?vue&type=script&lang=js&"
import style0 from "./OsmResult.vue?vue&type=style&index=0&id=04d22396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d22396",
  null
  
)

export default component.exports